import './Admin.scss';
import { useUser } from '../../context/UserProvider';
import { Button } from 'primereact/button';
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';

function Admin() {
    const { error, setErrorState, clearError } = useUser();

    return <>
        <div className="admin-page">
           
            {error &&
                <div className='errorMessage'>
                    <span>{error}</span>
                    <span>
                        <Button variant="solid" color="danger" onClick={clearError}>X</Button>
                    </span>
                </div>
            }

            <Outlet />
            {/* The Outlet component will render the nested routes defined in the Admin route in App.js */}
        </div>
    </>
}

export default Admin;